import styled from 'styled-components';
import { ReactComponent as Alert } from '../../assets/icons/alert.svg';
import { ReactComponent as CheckCircle } from '../../assets/icons/check-circle.svg';

export const ToastWrapper = styled.div`
  padding:20px 32px;
  display:flex;
  justify-content:space-between;
`;

export const IconWarning = styled.div`
  padding:14px 25px 14px 0;
`;

export const ToastMessage = styled.div`
  font-weight:400;
  font-size:13px;
  color:${props=>props.theme.colors.white};
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  word-break: break-word;
`;

export const ToastColumn = styled.div`
  display:flex;
  flex-direction:column;
  width:213px;
`;

export const TitleMessage = styled.div`
  font-weight:700;
  font-size:13px;
  margin-bottom:8px;
  color:${props=>props.theme.colors.white};
`;

export const IconAlert = styled(Alert)`
  width:25px;
  height:22px;
`;

export const IconCheckCircle = styled(CheckCircle)`
    width:28px;
    height:28px;
`;